export default __webpack_public_path__ + "static/powerorbs-ed0e9af1e4dac7c84fa1e771ac138fb7.gif";